<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <!--用戶數據-->
      <div class="block">
        <div class="header">
          <div class="charts-title">用戶數據</div>
        </div>
        <jj-summary :summary-data="userData.summaryBlock"></jj-summary>
        <jj-charts :charts-data="userData.chartsBlock" @time="changeTime"></jj-charts>
      </div>
      <!--會員數據-->
      <div class="block">
        <div class="header">
          <div class="charts-title">會員數據</div>
        </div>
        <jj-summary :summary-data="vipsData.summaryBlock"></jj-summary>
        <jj-charts :charts-data="vipsData.chartsBlock" @time="changeTime"></jj-charts>
      </div>
      <!--訂單數據-->
      <div class="block">
        <div class="header">
          <div class="charts-title">訂單數據</div>
        </div>
        <jj-summary :summary-data="orderData.summaryBlock"></jj-summary>
        <jj-charts :charts-data="orderData.chartsBlock" @time="changeTime"></jj-charts>
      </div>
      <!--瀏覽數據-->
      <div class="block">
        <div class="header">
          <div class="charts-title">瀏覽數據</div>
          <div>
            <button class="jj-button bg-f9 radius-25" :class="browseActiveIndex===0?'jj-button-active':''"
                    @click="changeBlock(0)">全部
            </button>
            <button class="jj-button bg-f9 radius-25" :class="browseActiveIndex===1?'jj-button-active':''"
                    @click="changeBlock(1)">JJ日記
            </button>
          </div>
        </div>
        <jj-summary :summary-data="browseActiveIndex===0?browseData.summaryBlock:JJData.summaryBlock"></jj-summary>
        <jj-charts :charts-data="browseActiveIndex===0?browseData.chartsBlock:JJData.chartsBlock"
                   @time="changeTime"></jj-charts>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
import JjSummary from "./components/JjSummary";
import JjCharts from "./components/JjCharts";

export default {
  data() {
    return {
      navBlock: '首頁',
      navtitle: '數據概覽',
      dialogVisible: false,
      startTime: '',
      endTime: '',
      browseActiveIndex: 0,
      userData: {
        summaryBlock: [],
        chartsBlock: [{
          type: 'line',
          activeIndex: 0,
          title: ['活躍用戶', '新增用戶', '累計用戶'],
          name: '',
          timeArr: [],
          timepicker: true,
          dataArr: [[], [], []],
          dateArr: [],
          id: 'userCharts'
        }]
      },
      vipsData: {
        summaryBlock: [],
        chartsBlock: [{
          type: 'line',
          activeIndex: 0,
          title: ['新增會員', '累計會員'],
          name: '',
          timeArr: [],
          timepicker: true,
          dataArr: [[], []],
          dateArr: [],
          id: 'vipsCharts'
        }, {
          type: 'area',
          name: '會員占比',
          title: '',
          timeArr: [],
          timepicker: true,
          dataArr: [{title: '會員數量', data: []}, {title: '用戶數量', data: []},],
          dateArr: [],
          id: 'vipsPerCharts'
        }]
      },
      orderData: {
        summaryBlock: [],
        chartsBlock: [{
          type: 'line',
          activeIndex: 0,
          title: ['新增訂單', '累計訂單'],
          name: '',
          timeArr: [],
          timepicker: true,
          dataArr: [[], []],
          dateArr: [],
          id: 'orderCharts'
        }, {
          type: 'area',
          title: '',
          name: '訂單會員占比',
          timeArr: [],
          timepicker: true,
          dataArr: [{title: '總訂單', data: []}, {title: '會員訂單', data: []},],
          dateArr: [],
          id: 'orderPerCharts'
        }]
      },
      browseData: {
        summaryBlock: [],
        chartsBlock: [{
          type: 'area',
          title: '',
          name: '瀏覽數據',
          timeArr: [],
          timepicker: true,
          dataArr: [{title: '新增喜歡', data: []}, {title: '新增留言', data: []}, {title: '新增瀏覽', data: []}],
          dateArr: [],
          id: 'browseCharts'
        }, {
          type: 'table',
          activeIndex: 0,
          title: ['喜歡最多', '留言最多', '瀏覽最多'],
          name: '30天內最多',
          timepicker: false,
          timeArr: [],
          dataArr: [],
          id: 'browseTable'
        }]
      },
      JJData: {
        summaryBlock: [],
        chartsBlock: [{
          type: 'area',
          title: '',
          name: '瀏覽數據',
          timeArr: [],
          timepicker: true,
          dataArr: [{title: '新增喜歡', data: []}, {title: '新增留言', data: []}, {title: '新增瀏覽', data: []}],
          dateArr: [],
          id: 'JJCharts'
        }, {
          type: 'table',
          activeIndex: 0,
          title: ['喜歡最多', '留言最多', '瀏覽最多'],
          name: '30天內最多',
          timepicker: false,
          timeArr: [],
          dataArr: [],
          id: 'browseTable'
        }]
      },
      dateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; // 限制只可以选择今天及今天之前的日期
        }
      },
    }
  },
  created() {
    // this.endTime = this.$getDay(0);//当前时间
    this.endTime = this.$getDay(-1);//当前时间前一天
    this.startTime = this.$getDay(-7);
    this.getInitUserData(0, 0, 0);
    this.getInitOrderData(0, 0, 0)
    this.getInitJjData(0, 0, 0)
    this.getInitBrowseData(0, 0, 0)
    this.getInitJjHistoryData()
    this.getInitBrowseHistoryData()
  },
  mounted() {
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {

    // 初始化用户数据,mode 初始化0,用户数据1,会员数据2，会员占比数据3
    getInitUserData(startTime, endTime, mode) {
      let _this = this;

      if (startTime === 0 || endTime === 0) {
        startTime = _this.startTime + ' 00:00:00'
        endTime = _this.endTime + ' 23:59:59'
        _this.userData.chartsBlock.forEach(v => {
          v.timeArr.push(_this.startTime, _this.endTime)
        })
        _this.vipsData.chartsBlock.forEach(v => {
          v.timeArr.push(_this.startTime, _this.endTime)
        })
      } else {
        startTime = startTime + ' 00:00:00'
        endTime = endTime + ' 23:59:59'
      }
      _this.$post(`/request/member/memberDataByDate?startTime=${startTime}&endTime=${endTime}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          console.log(res)
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            if (mode === 0) {
              _this.userData.summaryBlock.push({
                'title': '活躍用戶',
                'yesterday': res.data[5].activityUsers,
                'today': res.data[6].activityUsers
              }, {
                'title': '新增用戶',
                'yesterday': res.data[5].newUsers,
                'today': res.data[6].newUsers
              }, {
                'title': '累計用戶',
                'yesterday': res.data[5].totalUsers,
                'today': res.data[6].totalUsers
              })
              _this.vipsData.summaryBlock.push({
                'title': '新增會員',
                'yesterday': res.data[5].newVips,
                'today': res.data[6].newVips
              }, {
                'title': '累計會員',
                'yesterday': res.data[5].totalVips,
                'today': res.data[6].totalVips
              })
              res.data.forEach(v => {
                _this.userData.chartsBlock[0].dataArr[0].push(v.activityUsers)
                _this.userData.chartsBlock[0].dataArr[1].push(v.newUsers)
                _this.userData.chartsBlock[0].dataArr[2].push(v.totalUsers)
                _this.userData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
                _this.vipsData.chartsBlock[0].dataArr[0].push(v.newVips)
                _this.vipsData.chartsBlock[0].dataArr[1].push(v.totalVips)
                _this.vipsData.chartsBlock[1].dataArr[0].data.push(v.totalVips)
                _this.vipsData.chartsBlock[1].dataArr[1].data.push(v.totalUsers)
                _this.vipsData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
                _this.vipsData.chartsBlock[1].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))

              })
            } else if (mode === 1) {
              _this.userData.chartsBlock[0].dataArr[0] = []
              _this.userData.chartsBlock[0].dataArr[1] = []
              _this.userData.chartsBlock[0].dataArr[2] = []
              _this.userData.chartsBlock[0].dateArr = []
              res.data.forEach(v => {
                _this.userData.chartsBlock[0].dataArr[0].push(v.activityUsers)
                _this.userData.chartsBlock[0].dataArr[1].push(v.newUsers)
                _this.userData.chartsBlock[0].dataArr[2].push(v.totalUsers)
                _this.userData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else if (mode === 2) {
              _this.vipsData.chartsBlock[0].dataArr[0] = []
              _this.vipsData.chartsBlock[0].dataArr[1] = []
              _this.vipsData.chartsBlock[0].dateArr = []
              res.data.forEach(v => {
                _this.vipsData.chartsBlock[0].dataArr[0].push(v.newVips)
                _this.vipsData.chartsBlock[0].dataArr[1].push(v.totalVips)
                _this.vipsData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else if (mode === 3) {
              _this.vipsData.chartsBlock[1].dataArr[0].data = []
              _this.vipsData.chartsBlock[1].dataArr[1].data = []
              _this.vipsData.chartsBlock[1].dateArr = []
              res.data.forEach(v => {
                _this.vipsData.chartsBlock[1].dataArr[0].data.push(v.totalVips)
                _this.vipsData.chartsBlock[1].dataArr[1].data.push(v.totalUsers)
                _this.vipsData.chartsBlock[1].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            }
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    // 获取订单初始化数据,mode 初始化0,订单数据1,订单占比数据2
    getInitOrderData(startTime, endTime, mode) {
      let _this = this;
      if (startTime === 0 || endTime === 0) {
        startTime = _this.startTime + ' 00:00:00'
        endTime = _this.endTime + ' 23:59:59'
        _this.orderData.chartsBlock.forEach(v => {
          v.timeArr.push(_this.startTime, _this.endTime)
        })
      } else {
        startTime = startTime + ' 00:00:00'
        endTime = endTime + ' 23:59:59'
      }

      _this.$post(`/request/member/getOrderData?startTime=${startTime}&endTime=${endTime}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            if (mode === 0) {
              _this.orderData.summaryBlock.push({
                'title': '新增訂單',
                'yesterday': res.data[5].newOrder,
                'today': res.data[6].newOrder
              }, {
                'title': '累計訂單',
                'yesterday': res.data[5].totalOrder,
                'today': res.data[6].totalOrder
              })
              res.data.forEach(v => {
                _this.orderData.chartsBlock[0].dataArr[0].push(v.newOrder)
                _this.orderData.chartsBlock[0].dataArr[1].push(v.totalOrder)
                _this.orderData.chartsBlock[1].dataArr[0].data.push(v.totalOrder)
                _this.orderData.chartsBlock[1].dataArr[1].data.push(v.totalVipOrder)
                _this.orderData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
                _this.orderData.chartsBlock[1].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else if (mode === 1) {
              _this.orderData.chartsBlock[0].dataArr[0] = []
              _this.orderData.chartsBlock[0].dataArr[1] = []
              _this.orderData.chartsBlock[0].dateArr = []
              res.data.forEach(v => {
                _this.orderData.chartsBlock[0].dataArr[0].push(v.newOrder)
                _this.orderData.chartsBlock[0].dataArr[1].push(v.totalOrder)
                _this.orderData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else if (mode === 2) {
              _this.orderData.chartsBlock[1].dataArr[0].data = []
              _this.orderData.chartsBlock[1].dataArr[1].data = []
              _this.orderData.chartsBlock[1].dateArr = []
              res.data.forEach(v => {
                _this.orderData.chartsBlock[1].dataArr[0].data.push(v.totalOrder)
                _this.orderData.chartsBlock[1].dataArr[1].data.push(v.totalVipOrder)
                _this.orderData.chartsBlock[1].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            }
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    //獲取jj日記數據，mode 初始化0，数据浏览1
    getInitJjData(startTime, endTime, mode) {
      let _this = this;
      if (startTime === 0 || endTime === 0) {
        startTime = _this.startTime + ' 00:00:00'
        endTime = _this.endTime + ' 23:59:59'
        _this.JJData.chartsBlock.forEach(v => {
          v.timeArr.push(_this.startTime, _this.endTime)
        })
      } else {
        startTime = startTime + ' 00:00:00'
        endTime = endTime + ' 23:59:59'
      }
      _this.$post(`/request/member/getDiaryData?startTime=${startTime}&endTime=${endTime}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            if (mode === 0) {
              _this.JJData.summaryBlock.push({
                'title': '新增喜歡',
                'yesterday': res.data[5].newLikes,
                'today': res.data[6].newLikes
              }, {
                'title': '新增留言',
                'yesterday': res.data[5].newComment,
                'today': res.data[6].newComment
              }, {
                'title': '新增瀏覽',
                'yesterday': res.data[5].newViews,
                'today': res.data[6].newViews
              })
              res.data.forEach(v => {
                _this.JJData.chartsBlock[0].dataArr[0].data.push(v.newLikes)
                _this.JJData.chartsBlock[0].dataArr[1].data.push(v.newComment)
                _this.JJData.chartsBlock[0].dataArr[2].data.push(v.newViews)
                _this.JJData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else {
              _this.JJData.chartsBlock[0].dataArr[0].data = []
              _this.JJData.chartsBlock[0].dataArr[1].data = []
              _this.JJData.chartsBlock[0].dataArr[2].data = []
              _this.JJData.chartsBlock[0].dateArr = []
              res.data.forEach(v => {
                _this.JJData.chartsBlock[0].dataArr[0].data.push(v.newLikes)
                _this.JJData.chartsBlock[0].dataArr[1].data.push(v.newComment)
                _this.JJData.chartsBlock[0].dataArr[2].data.push(v.newViews)
                _this.JJData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            }
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    //獲取所有數據，mode 初始化0，数据浏览1
    getInitBrowseData(startTime, endTime, mode) {
      let _this = this;
      if (startTime === 0 || endTime === 0) {
        startTime = _this.startTime + ' 00:00:00'
        endTime = _this.endTime + ' 23:59:59'
        _this.browseData.chartsBlock.forEach(v => {
          v.timeArr.push(_this.startTime, _this.endTime)
        })
      } else {
        startTime = startTime + ' 00:00:00'
        endTime = endTime + ' 23:59:59'
      }
      _this.$post(`/request/member/getArticleData?startTime=${startTime}&endTime=${endTime}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            if (mode === 0) {
              _this.browseData.summaryBlock.push({
                'title': '新增喜歡',
                'yesterday': res.data[5].newLikes,
                'today': res.data[6].newLikes
              }, {
                'title': '新增留言',
                'yesterday': res.data[5].newComment,
                'today': res.data[6].newComment
              }, {
                'title': '新增瀏覽',
                'yesterday': res.data[5].newViews,
                'today': res.data[6].newViews
              })
              res.data.forEach(v => {
                _this.browseData.chartsBlock[0].dataArr[0].data.push(v.newLikes)
                _this.browseData.chartsBlock[0].dataArr[1].data.push(v.newComment)
                _this.browseData.chartsBlock[0].dataArr[2].data.push(v.newViews)
                _this.browseData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            } else if (mode === 1) {
              _this.browseData.chartsBlock[0].dataArr[0].data = []
              _this.browseData.chartsBlock[0].dataArr[1].data = []
              _this.browseData.chartsBlock[0].dataArr[2].data = []
              _this.browseData.chartsBlock[0].dateArr = []
              res.data.forEach(v => {
                _this.browseData.chartsBlock[0].dataArr[0].data.push(v.newLikes)
                _this.browseData.chartsBlock[0].dataArr[1].data.push(v.newComment)
                _this.browseData.chartsBlock[0].dataArr[2].data.push(v.newViews)
                _this.browseData.chartsBlock[0].dateArr.push(v.recordDate.substring(5, 10).replace('-', '.'))
              })
            }
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    //獲取jj日記瀏覽數據
    getInitJjHistoryData() {
      let _this = this;
      let startTime = this.$getDay(-29) + ' 23:59:59'
      let endTime = _this.endTime + ' 23:59:59'
      _this.$post(`/request/member/getTopArticle?startTime=${startTime}&endTime=${endTime}&type=1`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            _this.JJData.chartsBlock[1].dataArr.push(res.data.likeList, res.data.commentList, res.data.viewList)
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    // 獲取新聞數據
    getInitBrowseHistoryData() {
      let _this = this;
      let startTime = this.$getDay(-29) + ' 23:59:59'
      let endTime = _this.endTime + ' 23:59:59'
      _this.$post(`/request/member/getTopArticle?startTime=${startTime}&endTime=${endTime}&type=`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            if(res.data.length === 0) return;
            _this.browseData.chartsBlock[1].dataArr.push(res.data.likeList, res.data.commentList, res.data.viewList)
          } else {
            _this.dialogVisible = true
            _this.$propMessage(res.message, 'error', function () {
              _this.dialogVisible = false
            });
          }
        })
    },

    changeBlock(index) {
      this.browseActiveIndex = index
    },

    changeActiveIndex(data, index, index1) {
      data.chartsBlock[index].activeIndex = index1
    },

    growthFn(a, b) {
      let result = 0;
      if (a == 0) {
        if (b == 0) {
          result = 0;
        } else {
          result = Number(b) * 100;
        }
      } else {
        result = (Number(b) - Number(a)) / Number(a) * 100;
      }
      return result.toFixed(2)
    },

    changeTime(value, type) {
      if (type === 'userCharts') {
        this.getInitUserData(value[0], value[1], 1)
      } else if (type === 'vipsCharts') {
        this.getInitUserData(value[0], value[1], 2)
      } else if (type === 'vipsPerCharts') {
        this.getInitUserData(value[0], value[1], 3)
      } else if (type === 'orderCharts') {
        this.getInitOrderData(value[0], value[1], 1)
      } else if (type === 'orderPerCharts') {
        this.getInitOrderData(value[0], value[1], 2)
      } else if (type === 'browseCharts') {
        this.getInitBrowseData(value[0], value[1], 1)
      } else if (type === 'JJCharts') {
        this.getInitJjData(value[0], value[1], 1)
      }
    }
  },
  components: {
    JjCharts,
    JjSummary,
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less">
.paddingContent {
  .block {
    margin-bottom: 0.5rem;

    .header {
      display: flex;
      justify-content: space-between;

      .charts-title {
        font-size: 0.2rem;
        color: #292929;
        text-align: left;
      }
    }

    .charts-block {
      display: flex;

      .charts-item {
        flex: 1;
        padding: 0.4rem 0.24rem 0.5rem 0.24rem;
        border-radius: 0.12rem;
        background-color: #FFFFFF;
        margin-right: 0.28rem;

        .charts-header {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .charts-choice {
            text-align: left;
          }
        }

        .table {
          margin-top: 0.5rem;
        }

        .tableWrap {
          min-height: 3.5rem;
          max-width: 15.8rem;
          background: #fff;
          border-radius: 12px;
          margin-top: 0.32rem;
          box-shadow: 0px 6px 18px rgba(227, 227, 241, 1);
        }
      }

      .charts-item:last-child {
        margin-right: 0;
      }
    }
  }

  .cursor {
    cursor: default;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 2.5rem;
  }

  .el-date-editor .el-range-separator {
    padding: 0;
  }

  .center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/userData.vue